
$(function () {
    var _PageScript = (function () {
        var $scope = $('.page');
        var $form = $scope.find('form');
        __Ajax.namespace = "manager";

        var galleryModal = function (img) {
            var item = img.closest(".galeria-item");
            document.querySelectorAll('.in-modal').forEach(x => {
                x.classList.remove("in-modal");
            });
            item.classList.add('in-modal');

            var src = img.dataset.fullimgurl;
            var modal = document.querySelector(".modal-gallery");
            if (!modal) return;

            var modalImg = modal.querySelector("img");
            if (!modalImg) return;
            modalImg.setAttribute("src", src);

            var caption = modal.querySelector(".gallery-caption");
            if (!caption) return;
            caption.innerHTML = item.dataset.caption;

            var link = modal.querySelector(".gallery-piece-link");
            if (!link) return;
            link.href = item.dataset.link;
            link.Text = item.dataset.title;
            var myModal = new bootstrap.Modal(modal);
            myModal.show();
        };

        var galleryModalMove = function (action) {
            var $target;
            if (action === "right") {
                $target = $('.galeria-item.in-modal').next();
                if ($target.length === 0) {
                    $target = $('.galeria-item:first()');
                }
            } else {
                $target = $('.galeria-item.in-modal').prev();
                if ($target.length === 0) {
                    $target = $('.galeria-item:last()');
                }
            };

            galleryModal($target);
        };

        var galleryMore = function () {
            var next = $(".galeria-item").length / parseInt($('#PageSize').val());

            __Ajax({
                url: '/api/galeria/pager',
                data: {
                    "data": {
                        "Page": next
                    }
                },
                start: function () {
                    $('.action-more').symloading("btn");
                },
                done: function (response) {
                    $('.galeria-list').append(response.View);
                    __site.publiStaticScan();
                },
                end: function () {
                    $('.action-more').symloading("hide");
                }
            });

            if ($(".galeria-item").length === parseInt($('#ItemsInDB').val())) {
                $('.action-more').hide();
            }

        };

        return {
            init: function () {
                const cont = document.querySelector(".galeria-list");

                cont.addEventListener("click", (e) => {
                    const img = e.target.closest(".galeria-item img");
                    if (!img) return; // has hecho clic en otra cosa
                    galleryModal(img);
                });

                $scope.on("click", ".modal-gallery .action-move", function () {
                    galleryModalMove($(this).attr("data-action"));
                });

                // .action-more:click
                $('.action-more').on("click", function () {
                    galleryMore();
                });

                $('body').trigger("publi.local.end");
            }
        };
    })();

    _PageScript.init();
});
